'use client';

import { useEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { getCookie } from 'cookies-next';
import { hideBanner } from './util';
import { COOKIE_KEYS } from '../../../../constants/constant';

const MailOrderBar = ({ bgColor, mailOrderHeaderText }: { bgColor: string; mailOrderHeaderText: string }) => {
  const [showBanner, setShowBanner] = useState(false);
  const [bannerTitle, setBannerTitle] = useState('');
  const pathName = usePathname()?.split('/')?.[1];
  const searchParams = useSearchParams();
  const currentUrl = `/${pathName}/?${searchParams.toString()}`;

  useEffect(() => {
    setShowBanner(hideBanner(pathName));
    const pageHistory = getCookie(COOKIE_KEYS.URL_HISTORY);
    if (pageHistory) {
      const parsedPageHistory = JSON.parse(pageHistory);
      const pageName = parsedPageHistory?.['search']?.name ?? '';
      switch (pageName) {
        case 'Begin Mail Order':
          return setBannerTitle(mailOrderHeaderText);
        default:
          return setBannerTitle('');
      }
    }
  }, [currentUrl]);
  return (
    <>
      {showBanner && bannerTitle ? (
        <section className={`bg-[${bgColor}] flex h-[38px] items-center px-6 text-16 font-bold text-white`}>
          {bannerTitle}
        </section>
      ) : (
        <></>
      )}
    </>
  );
};

export default MailOrderBar;
